import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getProjectTemplate = () => {
  const url = `${API_ROOT}/proposal/project/template`
  return doGet(url)
}

export const saveProjectTemplate = (request) => {
  const url = `${API_ROOT}/proposal/project/template`
  return doPost(url, request)
}
